<template>
  <div class="relative flex min-h-0 flex-1 flex-col">
    <Transition name="swap">
      <slot />
    </Transition>
  </div>
</template>

<script setup lang="ts">
// Crossfades the swapping content of an already-open panel. The owner passes a
// single keyed child (or v-if/v-else siblings — exactly one renders): when the
// key changes, the old copy leaves while the new enters. The leaving copy is
// pulled out of flow (position: absolute) so the panel height tracks the
// entering copy instead of collapsing into a gap mid-swap.
//
// Swipe-ready: to slide instead of fade, add `transform: translateX(...)` to
// the `-enter-from`/`-leave-to` rules and (for direction) a prop that switches
// the Transition `name` between forward/back variants.
</script>

<style scoped>
.swap-enter-active,
.swap-leave-active {
  transition: opacity var(--raw-out-quart--slow);
}
/* Leaving copy leaves the flow so the panel height tracks the entering copy
   (no collapse/gap). It overlays the new content while fading out. */
.swap-leave-active {
  position: absolute;
  inset: 0;
}
.swap-enter-from,
.swap-leave-to {
  opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
  .swap-enter-active,
  .swap-leave-active {
    transition: opacity 0.12s linear;
  }
}
</style>
